<template>
    <div :class="{'file-input-wrapper': !storageBlocked}">
        <template v-if="!storageBlocked">
            <input v-if="!reset" ref="fileInput" :name="name" type="file" :class="size" :id="_id" :required="_required" @change="filesChanged"
                v-bind="{...$attrs, ...ariaValidationAttributes}" aria-label="Datei auswählen"/>
            <span v-if="hasFiles" v-interact="clear" class="icon-interact" aria-label="Dateiauswahl zurücksetzen">
                <i aria-hidden="true" class="material-icons" role="img">clear</i>
            </span>
        </template>
        <template v-else>
            <div class="info"><i class="material-icons md-light" aria-hidden="true" role="img">info</i>
                <div>Die Upload-Funktion ist aktuell gesperrt, da der Speicherplatz überschritten ist.</div>
            </div>
        </template>
    </div>
</template>

<script lang="ts">
    import {Component, Prop} from 'vue-facing-decorator';
    import {AbstractFormInput} from '../../mixins/AbstractFormInput';
    import FormRow from './FormRow.vue';

    @Component({
        name: 'FormInputFile',
        inheritAttrs: false,
        emits: ['changed-files'],
    })
    export default class FormInputFile extends AbstractFormInput
    {
        readonly $parent: FormRow | any;

        readonly $refs: {
            fileInput: HTMLInputElement
        };

        @Prop({
            type: String,
        }) modelValue: string;

        @Prop({
            type: String,
            required: true,
        }) name: string;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) ignoreStorageBlocked: boolean;

        @Prop({
            type: String,
            default: 'long',
            required: false,
            validator(value: string): boolean
            {
                return ['long', 'medium', 'small'].includes(value);
            },
        }) size: string;

        hasFiles: boolean = false;

        reset: boolean = false;

        get storageBlocked()
        {
            return !this.ignoreStorageBlocked && this.$store.state.layoutData.storageBlocked;
        }

        filesChanged(event: Event)
        {
            const length  = (event.target as HTMLInputElement).files!.length;
            this.hasFiles = length > 0;
            this.$emit('changed-files', this.hasFiles, length);
        }

        clear(): void
        {
            this.reset = true;
            this.$nextTick(() =>
            {
                this.hasFiles = false;
                this.reset    = false;
                this.$emit('changed-files', this.hasFiles, 0);
            });
        }

        focus()
        {
            this.$refs.fileInput && this.$refs.fileInput.click();
        }
    };
</script>